export default __webpack_public_path__ + "static/media/alignment_icon.6aff5b02.svg";